import { ReactComponent } from "./right-angle-bracket-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const RightAngleBracketLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default RightAngleBracketLineIcon;
